<template>

    <v-container class="fill-height data-container" fluid>

        <v-stepper class="stepper" v-model="currentStep">
            <v-stepper-header style="height: 50px;">
                <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable color="#c42111" :rules="[() => validation.alarmConditionsValidation($props.alarmCorrelation.alarm_conditions)]">Alarm Conditions</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable color="#c42111" :rules="[() => validation.groupingCriteriaValidation($props.alarmCorrelation.alarm_groupings)]">Grouping Criteria</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable color="#c42111" :rules="[() => validation.stepForm($refs.newAlarmForm)]">Correlation Alarm</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step class="stepper-step" step="4" :complete="currentStep > 4" editable color="#c42111" :rules="[() => validation.stepForm($refs.correlationAlarmDetailsForm)]">Details</v-stepper-step>
            </v-stepper-header>
        

            <v-stepper-items class="stepper-content-container">
                <v-stepper-content :step="1" class="stepper-content alarm-conditions-step">
                    <alarm-conditions-list allow-select :localeList="$props.alarmCorrelationsResources.locale_list" :alarmConditions="$props.alarmCorrelationsResources.alarm_conditions" :selectedAlarmConditions="$props.alarmCorrelation.alarm_conditions" :lockSave="lockSave" :alarmCorrelationId="$props.alarmCorrelation.correlation_id" @selected="(selected) => {$props.alarmCorrelation.alarm_conditions = selected}"  />
                </v-stepper-content>

                <v-stepper-content :step="2" class="stepper-content">
                    <div class="info-container mb-4">
                        <v-icon class="mr-2">mdi-information</v-icon>
                        <span>Learn about RegEx(regular expressions) <a target="_blank" href="https://regex101.com/" style="color: #ffffff">here</a></span>
                    </div>
                    <grouping-criteria :groupingCriteriaList="$props.alarmCorrelation.alarm_groupings" @delete="deleteAlarmLocationDescription" />
                </v-stepper-content>

                <v-stepper-content :step="3" class="stepper-content">
                    <v-form ref="newAlarmForm" class="fill-height" :lazy-validation="true" v-model="newAlarmFormValid">
                        <div class="info-container mb-4">
                            <v-icon class="mr-2">mdi-information</v-icon>
                            <span>When all required <i>alarm conditions</i> are met, the system will create this Correlation Alrarm as the parent alarm. All alarms that matched the <i>alarm conditions</i> will become children of this new alarm.</span>
                        </div>

                        <v-row>
                            <v-col cols="12">
                                <custom-alarm-field label="Alarm Office" :groupingCriteriaList="$props.alarmCorrelation.alarm_groupings" v-model="$props.alarmCorrelation.alarm_office" />
                                <v-text-field dense readonly v-model="$props.alarmCorrelation.alarm_office" color="#c42111" :rules="[$store.state.validationFuncs.required($props.alarmCorrelation.alarm_office, 'Office')]"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <custom-alarm-field label="Alarm Location" :groupingCriteriaList="$props.alarmCorrelation.alarm_groupings" v-model="$props.alarmCorrelation.alarm_location" />
                                <v-text-field dense readonly v-model="$props.alarmCorrelation.alarm_location" color="#c42111" :rules="[$store.state.validationFuncs.required($props.alarmCorrelation.alarm_location, 'Location')]"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <custom-alarm-field label="Alarm Description" :groupingCriteriaList="$props.alarmCorrelation.alarm_groupings" v-model="$props.alarmCorrelation.alarm_description" />
                                <v-text-field dense readonly v-model="$props.alarmCorrelation.alarm_description" color="#c42111" :rules="[$store.state.validationFuncs.required($props.alarmCorrelation.alarm_description, 'Description')]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select label="Alarm Locale" v-model="$props.alarmCorrelation.alarm_locale" color="#c42111" :items="$props.alarmCorrelationsResources.locale_list" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select label="Alarm Severity" v-model="$props.alarmCorrelation.alarm_severity" :items="severityList" color="#c42111" :rules="[$store.state.validationFuncs.required($props.alarmCorrelation.alarm_severity, 'Severity')]"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="$props.alarmCorrelation.alarm_service_affecting" label="Alarm Service Affecting" color="#c42111"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content :step="4" class="stepper-content">
                    <v-form ref="correlationAlarmDetailsForm" class="fill-height" :lazy-validation="true" v-model="correlationAlarmDetailsFormValid">
                        <v-container class="fill-height" fluid>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Correlation Name" v-model="$props.alarmCorrelation.correlation_name" color="#c42111" :rules="[$store.state.validationFuncs.required($props.alarmCorrelation.correlation_name, 'Correlation Name')]"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-radio-group v-model="timeLimited" row>
                                        <v-radio label="Always Active" :value="false" color="#c42111"></v-radio>
                                        <v-radio label="Time-Limited" :value="true" color="#c42111"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-datetime-picker ref="startDatetime" label="Active From" color="#c42111" v-model="$props.alarmCorrelation.active_starting" :disabled="!timeLimited" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="{color: '#c42111', rules: [$store.state.validationFuncs.timeLimited(timeLimited, $props.alarmCorrelation.active_starting, $props.alarmCorrelation.active_until, 'Active From must be before Active Until')]}"></v-datetime-picker>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-datetime-picker ref="endDatetime" label="Active Until" color="#c42111" v-model="$props.alarmCorrelation.active_until" :disabled="!timeLimited" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="{color: '#c42111', rules: [$store.state.validationFuncs.timeLimited(timeLimited, $props.alarmCorrelation.active_starting, $props.alarmCorrelation.active_until, 'Active From must be before Active Until')]}"></v-datetime-picker>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" md="6" xl="3">
                                    <v-checkbox v-model="$props.alarmCorrelation.stop_if_matches" label="End processing if this rule matches?" color="#c42111"></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12">
                                    <v-textarea v-model="$props.alarmCorrelation.documentation" outlined label="Rule Documentation" color="#c42111"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>


        <v-btn color="#c42111" class="mt-3 mr-3" @click="saveCorrelationClick" :disabled="lockSave">
            Save
            <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                <template v-slot:activator="{ on }">
                    <v-icon class="is-dirty-save-button-icon" v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>Pending Changes</span>
            </v-tooltip>
        </v-btn>
        <v-btn class="mt-3 mr-3" color="#c42111" @click="cancelClick">Cancel</v-btn>
    </v-container>

</template>

<script>
import AlarmConditionsList from "@/components/AlarmCorrelations/AlarmConditionsList";
import GroupingCriteria from "@/components/AlarmCorrelations/GroupingCriteria";
import CustomAlarmField from "@/components/AlarmCorrelations/CustomAlarmField";
export default {
    name: 'AlarmCorrelationsEdit',
    props: ['alarmCorrelation', 'alarmCorrelationsResources', 'lockSave'],
    components: {
        AlarmConditionsList,
        GroupingCriteria,
        CustomAlarmField
    },
    data: () => ({
        currentStep: 1,
        newAlarmFormValid: true,
        correlationAlarmDetailsFormValid: true,
        severityList: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        timeLimited: false,
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111',
        },
        dpProps: {
            color: '#c42111',
        },
        validation: {
            alarmConditionsValidation: (selectedAlarmConditions) => {return selectedAlarmConditions.filter(c => c.active).length >= 2},
            groupingCriteriaValidation: (groupings) => {return groupings.every(g => {return g.valid})},
            stepForm: (form) => ((form === undefined || form.validate()) || false),
        },
    }),

    computed: {

    },

    methods: {
        saveCorrelationClick: function() {
            if(this.validation.alarmConditionsValidation(this.$props.alarmCorrelation.alarm_conditions) && this.validation.groupingCriteriaValidation(this.$props.alarmCorrelation.alarm_groupings) && this.$refs.newAlarmForm.validate() && this.$refs.correlationAlarmDetailsForm.validate()) {
                this.$emit('save');
            }
        },

        deleteAlarmLocationDescription: function() {
            this.$props.alarmCorrelation.alarm_office = null;
            this.$props.alarmCorrelation.alarm_location = null;
            this.$props.alarmCorrelation.alarm_description = null;
        },

        cancelClick: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your changes without saving?',
                    type: 'warning',
                    confirmAction: () => {this.$store.commit('setIsDirty', false); this.$emit('cancel');}
                });
            }
            else {
                this.$emit('cancel');
            }
        }
    },

    watch: {
        alarmCorrelation: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
            },
            deep: true
        },

        timeLimited: {
            handler(newVal, oldVal) {
                if(!newVal) {
                    this.$props.alarmCorrelation.active_starting = null;
                    this.$props.alarmCorrelation.active_until = null;
                    this.$refs.startDatetime.date = "";
                    this.$refs.startDatetime.time = "";
                    this.$refs.endDatetime.date = "";
                    this.$refs.endDatetime.time = "";
                }
            }
        }
    },

    created() {
        this.$props.alarmCorrelation.alarm_groupings.forEach(g => {g.valid = true});
    },

    mounted() {
        this.timeLimited = (!!this.$props.alarmCorrelation.active_starting && !!this.$props.alarmCorrelation.active_until);
    },
};
</script>


<style scoped>
    .stepper {
        background: #424242; 
        height: calc(100vh - 126px);
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto;
        height: calc(100% - 55px); 
    }
    .stepper-content {
        height: 100%;
    }

    .data-container {
        padding: 0;
    }

    .week-day {
        display: inline-block;
        margin-right: 3em;
    }

    .week-day-label {
        display: block;
        font-weight: bold;
    }

    .alarm-condition-container {
        width: 100%;
        height: 100%;
        overflow: auto;
        max-height: calc(100vh - 300px);
    }
    .alarm-condition-container div {
        width: 100%;
    }

    .alarm-condition {
        background-color: #303030;
    }

    .info-container {
        background-color: #303030;
        border: #000000 solid 1px;
        border-radius: 5px;
        padding: 5px 10px;
        margin-bottom: 5px;
    }
    
    .required-alarm-conditions-container {
        height: calc(100% - 50px);
        border: #303030 solid 2px;
        border-radius: 5px;
    }

    .empty-area-container {
        position: absolute;
        text-align: center;
        top: calc(50% - 54px);
    }
    .empty-area-container span {
        color: gray;
        display: block;
        font-size: 36px;
    }
</style>

<style>

    .alarm-conditions-step .v-stepper__wrapper {
        height: 100%;
    }

</style>

    
